<template>
    <v-chip label :color="getNotificationColor(modelValue.type)" variant="tonal" class="notification-badge">
        <template #prepend>
            <notification-icon :model-value="modelValue.type" size="24" alt />
        </template>
        <span class="notification-badge__text text-h6 line-height-1 on-background ml-1">
            {{ title }}
        </span>
    </v-chip>
</template>

<script setup lang="ts">
import { NotificationMessageDto, NotificationMessageType } from '@/types/webapi';
import NotificationIcon from '../NotificationIcon/NotificationIcon.vue';
import { getNotificationColor } from '@/features/common/helpers';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

interface Props {
    modelValue: NotificationMessageDto;
}

const props = defineProps<Props>();
const { t } = useI18n();

const title = computed(() => {
    switch (props.modelValue.type) {
        case NotificationMessageType.Deviation:
            return t('common.resources.deviation', 'Deviation');

        case NotificationMessageType.Warning:
            return t('common.resources.warning', 'Information');

        case NotificationMessageType.Cancellation:
            return t('common.resources.cancellation', 'Cancellation');

        case NotificationMessageType.BookingArrangement:
        case NotificationMessageType.BookingConfirmation:
        case NotificationMessageType.OnlineBookingArrangement:
            return t('common.resources.booking', 'Booking arrangement');

        default:
            return t('common.resources.notice', 'Notice');
    }
});
</script>

<style lang="scss">
@use 'vuetify/settings' as *;

.notification-badge {
    border: 1px solid currentColor;
    padding: 0 $spacer !important;
}
</style>
